import footerLogo from '../../asset/footer-logo.png'
import textLogo from '../../asset/Coated & Uncoated Calcium carbonate.png'
import { Link } from 'react-router-dom';

function Footer() {

  return (
    <>
    <div className='footer d-flex flex-column flex-wrap justify-content-center align-items-center pt-5 '>
            <div className='mt-3 col-12 d-flex  align-items-center row  w-75'>
                <div className='d-flex justify-content-end col-3'>
                    <img src={footerLogo} className=' w-50' alt="" srcset="" />
                </div>
                <div className='col-9'>
                <img src={textLogo} className=' w-75' alt="" srcset="" />
                </div>
            </div>
            <hr className='w-75 text-white' />
            <div className=' col-12 d-flex flex-wrap w-75'>
                <div className="col-lg-4 d-flex col-12 justify-content-center">
                    <p className='pe-4'><Link to='/' className='text-white text-decoration-none'>Home</Link></p>
                    <p className='pe-4'><Link to='/about' className='text-white text-decoration-none'>About</Link></p>
                    <p className='pe-4'><Link to='/applications' className='text-white text-decoration-none'>Applications</Link></p>
                    <p className='pe-4'><Link to='/contact' className='text-white text-decoration-none'>Contact US</Link></p>
                    </div>
                <div className="col-lg-4 col-12 d-flex justify-content-center pb-4 pb-0 text-white">&copy; Anab. All rights reserved</div>
                <div className="col-lg-4 col-12 text-white d-flex justify-content-center justify-content-lg-end">
                    <a className='text-white' href="https://www.linkedin.com/in/anab-for-calcium-carbonate-8b7142335/" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-linkedin-in ps-5"></i></a>
                    {/* <i class="fa-brands fa-facebook-f ps-5"></i> */}
                </div>
            </div>
    </div>
    </>
  );
}

export default Footer;
